import * as Comlink from 'comlink'
import axios from 'axios'
import qs from 'qs'

let o_Token = null
let o_RefreshToken = null
let t_TokenExpiration = null

const a_AllowedUrl = [
    process.env.VUE_APP_OAUTH_AUTH_SERVER + '/oauth/authorize',
    process.env.VUE_APP_OAUTH_AUTH_SERVER + '/oauth/token',
    process.env.VUE_APP_SMT_API_URL,
]
configureAxios()

const workerTasks = {
    async get (As_Url, o_Params) {
        try {
            const response = await axios.get(As_Url, {
                headers: {
                    'X-AUTH-TOKEN': o_Token,
                },
                params: o_Params,
            })
            return response.data
        } catch (error) {
            const o_Options = { status: 401, statusText: 'Request failed with status code 401' }
            const response = JSON.parse(JSON.stringify(error))
            response.status = 401
            return response
        }
    },
    async post (s_Url, o_Params) {
        try {
            const response = await axios.post(s_Url, o_Params, {
                headers: {
                    'X-AUTH-TOKEN': o_Token,
                },
            })
            return response.data
        } catch (error) {
            const o_Options = { status: 401, statusText: 'Request failed with status code 401' }
            const response = JSON.parse(JSON.stringify(error))
            response.status = 401
            return response
        }
    },
    async del (As_Url, o_Params) {
        try {
            const response = await axios.delete(As_Url, {
                headers: {
                    'X-AUTH-TOKEN': o_Token,
                },
                params: o_Params,
            })
            return response.data
        } catch (error) {
            const o_Options = { status: 401, statusText: 'Request failed with status code 401' }
            const response = JSON.parse(JSON.stringify(error))
            response.status = 401
            return response
        }
    },
    async getFile (As_Url, o_Params) {
        try {
            const response = await axios.get(As_Url, {
                headers: {
                    'X-AUTH-TOKEN': o_Token,
                },
                params: o_Params,
                responseType: 'blob'
            })
            const blob = new Blob([response.data],  {type: 'application/pdf'});
            const buffer = await blob.arrayBuffer();
            const view = new Uint8Array(buffer);
            return Comlink.transfer(view.buffer, [view.buffer])
        } catch (error) {
            const o_Options = { status: 401, statusText: 'Request failed with status code 401' }
            const response = JSON.parse(JSON.stringify(error))
            response.status = 401
            return response
        }
    },
    async getToken (s_Url, o_Params) {
        try {
            const response = await axios.post(s_Url, o_Params)
            o_Token = response.data.access_token
            o_RefreshToken = response.data.refresh_token
            t_TokenExpiration = response.data.expires_in
            return true
        } catch (error) {
            return false
        }
    },
    async refreshToken () {
        const s_Url = `${process.env.VUE_APP_OAUTH_AUTH_SERVER}/oauth/token`
        const o_Params = {
            grant_type: 'refresh_token',
            refresh_token: o_RefreshToken,
            client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
            client_secret: process.env.VUE_APP_OAUTH_CLIENT_SECRET,
        }
        if (await this.getToken(s_Url, o_Params)) {
            return true
        } else return false
    },
    getUserPersonID () {
        try {
            const o_Payload = JSON.parse(Buffer.from(o_Token.split('.')[1], 'base64').toString())
            return o_Payload.sub
        } catch (e) {
            return null
        }
    },
    isTokenNull () {
        if (o_Token === null) return true
        else return false
    },
    isSuperAdmin () {
        try {
            const o_Payload = JSON.parse(Buffer.from(o_Token.split('.')[1], 'base64').toString())
            const o_Header = JSON.parse(Buffer.from(o_Token.split('.')[0], 'base64').toString())
            if (o_Header.isa === true && o_Payload.scopes.includes('admin-all')) { return true }
        } catch (e) {
            return false
        }
        return false
    },
}

Comlink.expose(workerTasks)

function configureAxios () {
    axios.defaults.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }

    axios.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config
            if (error.response.status === 401 && !originalRequest._retry) {
                console.log('Error 401')
                originalRequest._retry = true
                if (await workerTasks.refreshToken()) { originalRequest.headers['X-AUTH-TOKEN'] = o_Token }
                return axios(originalRequest)
            }
            return Promise.reject(error)
        },
    )
}
